import React from 'react';

// KIKO Milano–style wordmark: wide geometric "PIKKO" with a subtle raised
// edge, small spaced-out "DUBAI" centered underneath.
const Logo = ({ className = '' }) => (
  <div className={`inline-flex flex-col items-center leading-none select-none ${className}`}>
    <span
      className="text-white uppercase"
      style={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 600,
        fontSize: '34px',
        letterSpacing: '0.12em',
        marginRight: '-0.12em', // offset trailing letter-spacing so text stays centered
        textShadow: '1px 1px 0 rgba(120,0,0,0.35)',
      }}
    >
      Pikko
    </span>
    <span
      className="text-white uppercase"
      style={{
        fontFamily: "'Montserrat', sans-serif",
        fontWeight: 700,
        fontSize: '11px',
        letterSpacing: '0.5em',
        marginRight: '-0.5em',
        marginTop: '5px',
      }}
    >
      Dubai
    </span>
  </div>
);

export default Logo;
